export const countries = {
  IRAN: {
    label: 'ایران'
  },
  INTERNATIONAL: {
    label: 'همهٔ کشورها'
  },
  NOT_IRAN: {
    label: 'خارج از ایران'
  }
};
export const priorities = {
  HIGH: {
    label: 'زیاد'
  },
  MEDIUM: {
    label: 'متوسط'
  },
  LOW: {
    label: 'کم'
  }
};
export const adTypes = {
  L: { label: 'login' },
  U: { label: 'continuous use' },
  S: { label: 'general search' },
  I: { label: 'introduce to friend' },
  A: { label: 'artist search' }
};

export const qualities = {
  H320: {
    label: '۳۲۰'
  },
  L128: {
    label: '۱۲۸'
  },
  L64: {
    label: '۶۴'
  }
}